module.exports = __webpack_public_path__ + "static/media/whyus.7b65e339.jpg";